import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Form, Input, Col } from 'antd';

// assets
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

function PasswordField({
  data,
  index,
  method,
  // default
  className
}) {
  const childClassNames = classNames('custom-form-column', 'password-input-column', className);


  const validatePassword = useCallback((rule, value, callback) => {
    if (value && value?.length > 0 && value?.length < 4) {
      return Promise.reject('Minimum 4 characters');
    } else {
      return Promise.resolve();
    }
  }, []);

  
  // const isRequired =
  //   method !== undefined && method == 'update'
  //     ? false
  //     : data?.required || false;

  let newPassValidator = {};
  if (method == "new" || method == "nouvel") {
    newPassValidator = {
      min: 4,
      validator: validatePassword,
      // validateTrigger: 'onSubmit',
    };
  }
  

  return data &&  (
    <Col
      key={data?.name + index + '-col'}
      md={data?.col || 24}
      xs={24}
      offset={data?.offset || null}
      className={classNames(childClassNames, (method !== undefined && method == 'update') && 'disabled-password')}
    >
      <Form.Item
        key={data?.name + index + '-item'}
        label={data?.displayLabel ? data?.label : data?.label}
        name={data?.name}
        className={data?.name + '-wrapper password-input'}
        initialValue={data?.value || ''}
        rules={[
          {
            required: data?.required || false,
            message: 'Mot de passe requis',
            //  validateTrigger: 'onSubmit',
          },
          newPassValidator,
        ]}
      >
        <Input.Password
          disabled={method !== undefined && method == 'update'}
          placeholder={
            data?.placeholder !== undefined ? data?.placeholder : data?.label
          }
          iconRender={visible =>
            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
          }
          autoComplete="new-password"
        />
      </Form.Item>
    </Col>
  );
};

PasswordField.defaultProps = {
  method: 'new',
  index: 1,
};

PasswordField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default memo(PasswordField);